import { useTranslation } from "react-i18next";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";

import { VehicleTable } from "./VehicleTable/VehicleTable";
import { VehiclesProvider } from "./VehiclesContext";

const VehiclesPage = () => {
    const { t } = useTranslation();

    return (
        <VehiclesProvider>
            <Panel title={<PanelTitle title={t("vehicles")} />}>
                <VehicleTable />
            </Panel>
        </VehiclesProvider>
    );
};
export default VehiclesPage;
